import { z } from "zod";

export const stediEligibilityStatusSchema = z.enum(["active", "inactive", "unknown", "failed"]);

export type StediEligibilityStatus = z.infer<typeof stediEligibilityStatusSchema>;
